export const RICH_TEXT_EDITOR_CONFIG = {
  modules: {
    toolbar: {
      container: [
        [{ 'header': [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        ['code'],  // Inline code
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        ['link', 'image'],
        ['code-block'],  // Code block
        [{ 'color': [] }, { 'background': [] }],
        ['clean'],
        ['insert-field']
      ],
      handlers: {
        'insert-field': function(value) {
          const quill = this.quill;
          const range = quill.getSelection();
          if (range) {
            // The actual insertion will be handled by the component
            const customEvent = new CustomEvent('insertField', {
              detail: { range }
            });
            document.dispatchEvent(customEvent);
          }
        }
      }
    },
    clipboard: {
      matchVisual: false
    }
  },
  formats: [
    'header', 'bold', 'italic', 'underline', 'strike',
    'code', 'list', 'bullet', 'link', 'image',
    'code-block', 'color', 'background'
  ]
};

// Custom button definition for the toolbar
export const insertFieldButton = function(Quill) {
  const icons = Quill.import('ui/icons');
  icons['insert-field'] = '<svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M19 3H5c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2m-2 10H7v-2h10v2Z"/></svg>';
};

// Function to insert field value
export const insertFieldValue = (quill, range, field, value) => {
  if (!quill || !range) return;

  const text = `{{${field}:${value}}}`;
  quill.deleteText(range.index, range.length);
  quill.insertText(range.index, text, {
    'color': '#1976d2',
    'background': '#e3f2fd',
    'field-value': true
  });
  quill.setSelection(range.index + text.length);
};

// You can add more specific configurations here if needed
export const MINIMAL_EDITOR_CONFIG = {
  modules: {
    toolbar: [
      ['bold', 'italic', 'underline'],
      ['code'],  // Inline code
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      ['link'],
      ['code-block'],  // Code block
      ['clean']
    ]
  },
  formats: [
    'bold', 'italic', 'underline', 'code',
    'list', 'bullet', 'link', 'code-block'
  ]
}; 